var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59998 7.2C3.59998 6.24522 3.97926 5.32955 4.65439 4.65441C5.32952 3.97928 6.2452 3.6 7.19998 3.6H16.8C17.7548 3.6 18.6704 3.97928 19.3456 4.65441C20.0207 5.32955 20.4 6.24522 20.4 7.2V16.8C20.4 17.7548 20.0207 18.6705 19.3456 19.3456C18.6704 20.0207 17.7548 20.4 16.8 20.4H7.19998C6.2452 20.4 5.32952 20.0207 4.65439 19.3456C3.97926 18.6705 3.59998 17.7548 3.59998 16.8V7.2ZM7.19998 5.4C6.72259 5.4 6.26475 5.58964 5.92718 5.92721C5.58962 6.26477 5.39998 6.72261 5.39998 7.2V16.8C5.39998 17.2774 5.58962 17.7352 5.92718 18.0728C6.26475 18.4104 6.72259 18.6 7.19998 18.6H16.8C17.2774 18.6 17.7352 18.4104 18.0728 18.0728C18.4103 17.7352 18.6 17.2774 18.6 16.8V7.2C18.6 6.72261 18.4103 6.26477 18.0728 5.92721C17.7352 5.58964 17.2774 5.4 16.8 5.4H7.19998Z",
    fill: "#D2D3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBox);
export default __webpack_public_path__ + "static/media/checkBox.b04ed62b5f27f5fc947a194d65a59eed.svg";
export { ForwardRef as ReactComponent };